<template>
  <LoadingContainer 
    :isLoading="loading" 
    :hasError="error"
    :hasNoResults="barrierStatuses.length === 0"
    errorMessage="Barrier info could not be retrieved."
    noResultsMessage="No Barrier Statuses found."
    color="alt-1"
  >
    <table
      v-if="barrierStatuses.length > 0 && !error"
      class="table table-striped table-bordered"
    >
      <thead>
        <tr>
          <th>Product</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(barrier, index) in barrierStatuses"
          :key="index"
        >
          <td>{{ barrier.productCode }}</td>
          <td>{{ barrier.barrierStatus }}</td>
        </tr>
      </tbody>
    </table>
  </LoadingContainer>
</template>

<script>
import { mapState } from 'vuex';
import LoadingContainer from '../../layout/LoadingContainer';

export default {
  components: {
    LoadingContainer
  },
  data: function() {
    return {
      loading: true,
      error: false,
      barrierStatuses: []
    }
  },
  computed: {
    ...mapState({
      bookingDetail: state => state.booking.bookingDetail
    })
  },
  methods: {
    async getBarrierStatuses() {
      this.error = false;
      this.loading = true;
      
      try {
        const { data } = await this.$store.dispatch('getBarrierStatus', this.bookingReference);
        this.barrierStatuses = data;
      } catch {
        this.error = true;
      }
      this.loading = false;
    }
  },
  watch: {
    bookingDetail: {
      handler: function(bookingDetail) {
        if (!bookingDetail) {
          return;
        }

        this.bookingReference = bookingDetail.bookingReference;
        this.getBarrierStatuses();
      },
      immediate: true
    }
  }
}
</script>
